var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 108,
    viewBox: "0 0 122 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2744 62.0633C14.007 61.9651 14.7398 61.8646 15.4708 61.7569C50.2272 56.8229 82.3283 41.4594 106.938 17.9807L107.421 17.5175L110.136 41.8742L87.1126 34.1584L86.0879 58.6165L64.6283 47.522L59.7754 72.8374L38.7471 57.1034L32.9776 78.8383L13.2757 62.0622",
    fill: "#31BEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.508 51.7095C101.922 52.1684 101.336 52.6239 100.75 53.0761C72.4908 74.7678 37.6712 87.557 1.23106 89.6294L0.50827 89.6707L19.8531 107.826L28.6462 86.3697L49.7496 101.224L56.7841 78.1173L79.6462 92.9717L81.4048 66.5639L102.508 76.4668V51.7095Z",
    fill: "#93CAE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToran);
export default __webpack_public_path__ + "static/media/toran.ec71741658ddd6ed2ae28ca340f6d513.svg";
export { ForwardRef as ReactComponent };